import {
  getOfferwallTypeLabel,
  isMfoLikeOfferwallType,
  normalizeOfferwallType,
  OfferwallTypes,
  TOfferwallType,
} from '@bprotsyk/aso-core';

export type { TOfferwallType };

export type OfferwallTypeFilter = 'all' | TOfferwallType;

export const OFFERWALL_TYPE_OPTIONS = OfferwallTypes.map((value) => ({
  label: getOfferwallTypeLabel(value),
  value,
}));

export const offerwallTypeLabel = getOfferwallTypeLabel;
export const normalizePanelOfferwallType = normalizeOfferwallType;
export const isMfoLikePanelOfferwallType = isMfoLikeOfferwallType;

export const getOfferwallTypeChipClass = (offerwallType?: string | null) =>
  isMfoLikeOfferwallType(offerwallType) ? 'chip-mfo' : 'chip-gambling';
